import React from "react";
import comparisonContent from "../comparisonContent.json";
import styles from "./ComparisonTable.module.css";

type ComparisonLanguage = "en" | "ko" | "ja";

const ComparisonTable: React.FC<{ language: string }> = ({ language }) => {
  const contentLanguage: ComparisonLanguage =
    language === "ko" || language === "ja" ? language : "en";
  const content = comparisonContent[contentLanguage];
  const isEnglishFallback = contentLanguage === "en" && language !== "en";

  return (
    <section className={styles.section} aria-labelledby="feature-comparison-title">
      <p className={styles.eyebrow}>{content.eyebrow}</p>
      <h2 id="feature-comparison-title">{content.title}</h2>
      <p className={styles.intro}>{content.intro}</p>
      {isEnglishFallback && (
        <p className={styles.languageNotice} lang="en">
          This comparison is currently provided in English. The rest of this page remains in your selected language.
        </p>
      )}
      <div className={styles.tableScroller} tabIndex={0} role="region" aria-label={content.title}>
        <table lang={contentLanguage}>
          <thead>
            <tr>
              <th scope="col">{content.criterion}</th>
              {content.products.map((product) => <th scope="col" key={product}>{product}</th>)}
            </tr>
          </thead>
          <tbody>
            {content.rows.map(([criterion, ...values]) => (
              <tr key={criterion}>
                <th scope="row">{criterion}</th>
                {values.map((value, index) => <td key={`${criterion}-${index}`}>{value}</td>)}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <p className={styles.disclosure}>{content.disclosure}</p>
      <ul className={styles.sources}>
        {comparisonContent.sources.map((source) => (
          <li key={source.url}><a href={source.url} target="_blank" rel="noopener noreferrer">{source.name}</a></li>
        ))}
      </ul>
    </section>
  );
};

export default ComparisonTable;
